<template>
  <div class="view-container survey-passing-page">
    <div class="extended-filter-block">
      <h2>Прохождение опроса</h2>
    </div>

    <div class="card">
      <div v-if="isLoaded" class="survey-passing">
        <div v-if="passing" class="survey-passing__meta">
          <div>
            user_id:
            <a
                v-if="passing.user_id"
                class="survey-passing__link"
                @click="router.push(`/staff/${passing.user_id}/edit`)"
            >
              {{ passing.user_id }}
            </a>
          </div>

          <div>Дата завершения: {{ finishDate }}</div>
        </div>

        <a-table
            class="survey-passing__table"
            :columns="columns"
            :data-source="questionRows"
            :pagination="false"
            :table-layout="'fixed'"
            rowKey="id"
            size="small"
        >
          <template #bodyCell="{ text }">
            {{ text }}
          </template>
        </a-table>
      </div>

      <div v-else class="table-preloader">
        <preloader />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Preloader from '@/components/Technical/Preloader.vue';
import useCheckRights from '@/mixins/useCheckRights';

export default {
  name: 'survey-passing-page',

  components: {
    Preloader,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { getRight } = useCheckRights();

    const isLoaded = ref(false);
    const passing = computed(() => store.state.periodicSurveys.passing);

    const columns = [
      {
        title: 'Вопрос',
        dataIndex: 'title',
        key: 'title',
        width: 260,
      },
      {
        title: 'Значение',
        dataIndex: 'value',
        key: 'value',
        width: 160,
      },
      {
        title: 'Коэффициент',
        dataIndex: 'coefficient',
        key: 'coefficient',
        width: 140,
        align: 'right',
      },
    ];

    const finishDate = computed(() => {
      return passing.value?.finished_at ?? '';
    });

    const formatValue = (value) => {
      if (value === null || value === undefined) {
        return '';
      }

      return typeof value === 'object' ? JSON.stringify(value) : value;
    };

    const questionRows = computed(() => {
      return Object.entries(passing.value?.answers ?? {}).map(([title, answer], index) => ({
        id: answer?.id ?? index,
        title,
        value: formatValue(answer?.value),
        coefficient: answer?.coefficient ?? '',
      }));
    });

    onBeforeMount(() => {
      store.dispatch('profile/getProfile').then(() => {
        if (!getRight('superadmin')) {
          router.push('/');
          return;
        }

        store.dispatch('periodicSurveys/getPassing', route.params.id)
            .catch(() => null)
            .finally(() => {
              isLoaded.value = true;
            });
      });
    });

    onBeforeUnmount(() => {
      store.dispatch('periodicSurveys/clearPassing');
    });

    return {
      router,
      isLoaded,
      passing,
      columns,
      questionRows,
      finishDate,
    };
  },
};
</script>

<style scoped lang="scss">
.view-container {
  padding-top: 0;
  padding-bottom: 0;
}

.survey-passing {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.survey-passing__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  color: var(--main-font);
  font-size: 14px;
  line-height: 120%;
}

.survey-passing__link {
  color: var(--main-green);
  cursor: pointer;
}

.survey-passing__link:hover {
  color: var(--polar-green-3);
}

.survey-passing__table {
  width: 100%;
}

.survey-passing__table :deep(.ant-table) {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
}

:deep(.ant-table-container),
:deep(.ant-table-content),
:deep(table) {
  border: 0 !important;
}

.survey-passing__table :deep(.ant-table-thead > tr > th),
.survey-passing__table :deep(.ant-table-tbody > tr > td) {
  padding: 8px 12px !important;
  color: var(--main-font) !important;
}

.survey-passing__table :deep(.ant-table-thead > tr > th) {
  font-weight: 600 !important;
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.table-preloader {
  padding: 50px;
}
</style>
